import { createRouter, createWebHistory, type Router } from 'vue-router';

import { legacyRoutes } from './legacyRoutes';
import { routes } from './routes';

export function createAppRouter(useCompositionRoutes: boolean): Router {
  return createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: useCompositionRoutes ? routes : legacyRoutes
  });
}
